var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (value) {
buf.push("<span>" + (jade.escape(null == (jade_interp = value) ? "" : jade_interp)) + "</span>");}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/projection/default-cell.jade
// module id = 86
// module chunks = 0